import React from "react";
import { Copy, Printer, FileText } from "lucide-react";
import { usePanelTheme } from "../context/themeContext";

export default function InvoicePdfToolbar({ invoice, client, onPrint, labels = {} }) {
  const { currentTheme, theme } = usePanelTheme();

  const invoiceNumber = invoice?.invoiceNumber || invoice?.number || "invoice";
  const invoiceDate = invoice?.invoiceDate || invoice?.date || "";
  const clientName =
    client?.name ||
    invoice?.clientName ||
    invoice?.companyName ||
    "client";

  const safeClientName = String(clientName)
    .trim()
    .replace(/\s+/g, "_")
    .replace(/[^\w-]/g, "");

  const pdfFileName = `${invoiceNumber}_${safeClientName}_${invoiceDate}.pdf`;

  const handleCopyPdfName = async () => {
    try {
      await navigator.clipboard.writeText(pdfFileName);
    } catch (error) {
      console.error("Failed to copy PDF name:", error);
    }
  };

  const shellClass =
    theme === "dark"
      ? "border-slate-700 bg-slate-900/70 text-slate-100"
      : "border-slate-200 bg-white text-slate-900";

  const secondaryButtonClass =
    theme === "dark"
      ? "border-slate-700 bg-slate-950 text-slate-100 hover:bg-slate-800"
      : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50";

  return (
    <div className={`rounded-[28px] border p-5 shadow-sm ${shellClass}`}>
      <div className="flex flex-col gap-5">
        <div className="min-w-0">
          <div className="flex items-center gap-3">
            <div
              className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl ${
                theme === "dark"
                  ? "bg-slate-800 text-slate-200"
                  : "bg-slate-100 text-slate-700"
              }`}
            >
              <FileText className="h-5 w-5" />
            </div>

            <div className="min-w-0">
              <h3 className="text-xl font-bold tracking-tight">{labels.pdfToolsTitle || "PDF & Print"}</h3>
              <p className={`mt-1 text-sm ${currentTheme.muted}`}>
                {labels.printHint || "Printo faturën ose kopjo emrin e file-it PDF."}
              </p>
            </div>
          </div>
        </div>

        {/* MOBILE: buttons stacked, DESKTOP: 2 columns */}
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
          <button
            type="button"
            onClick={onPrint}
            className={`inline-flex h-12 w-full items-center justify-center gap-2 rounded-2xl text-sm font-semibold shadow-sm transition ${
              theme === "dark"
                ? "bg-white text-slate-900 hover:bg-slate-200"
                : "bg-slate-900 text-white hover:bg-slate-800"
            }`}
          >
            <Printer className="h-4 w-4" />
            {labels.print || "Print / PDF"}
          </button>

          <button
            type="button"
            onClick={handleCopyPdfName}
            className={`inline-flex h-12 w-full items-center justify-center gap-2 rounded-2xl border px-4 text-sm font-semibold transition ${secondaryButtonClass}`}
          >
            <Copy className="h-4 w-4" />
            {labels.pdfCopyName || "Copy PDF name"}
          </button>
        </div>

        <div
          className={`flex min-h-[52px] items-center rounded-2xl border px-4 text-sm ${
            theme === "dark"
              ? "border-slate-700 bg-slate-900 text-slate-300"
              : "border-slate-200 bg-slate-50 text-slate-600"
          }`}
        >
          <span className="truncate">{pdfFileName}</span>
        </div>
      </div>
    </div>
  );
}